let obj = {
    name: 'fasddsfsaef'
}
// let lurl = '192.168.0.235:8080';
// var lurl = '101.37.151.192:8180'
// var lurl = 'www.ax168.com'
var lurl = window.location.host;
var serviceaddress = 'http://'+ lurl + '/admin_custom_ser/'
export default {obj, serviceaddress}



// WEBPACK FOOTER //
// ./src/global.js